const isValid = (str, mask) => {
  const masked = str.replace(/\d/g, '0');
  return mask.indexOf(masked) > -1;
};

export const formatMask = (str = '', mask) => {
  const numbers = str.replace(/\D/g, '');
  let specialCharCount = 0;

  if (isValid(str, mask)) {
    return str;
  }

  return mask
    .split('')
    .map((char, index) => {
      const fieldChar = numbers[index - specialCharCount];
      const isSpecialChar = ['-', '.', '/', '(', ')', ' '].indexOf(char) > -1;

      if (!fieldChar) {
        return null;
      }

      if (isSpecialChar) {
        specialCharCount++;
        return char;
      }
      return fieldChar;
    })
    .join('');
};
